// Фото портфолио. Перенесены из Airtable (таблица «Блоки» → «Портфолио»)
// в репозиторий: файлы лежат в public/portfolio/.
// Чтобы добавить/убрать работу — положите файл в public/portfolio/ и
// поправьте список ниже. Форма объекта совпадает с той, что ждёт ui-gallery.
const WIDTH = 640
const HEIGHT = 640

const files = [
  '/portfolio/work-1.jpg',
  '/portfolio/work-2.jpg',
  '/portfolio/work-3.jpg',
  '/portfolio/work-4.jpg',
  '/portfolio/work-5.jpg',
  '/portfolio/work-6.jpg',
  '/portfolio/work-7.jpg',
  '/portfolio/work-8.jpg',
  '/portfolio/work-9.jpg',
]

export const portfolio = files.map((url) => ({
  thumbnails: {
    full: { url, width: WIDTH, height: HEIGHT },
    large: { url, width: WIDTH, height: HEIGHT },
    small: { url, width: WIDTH, height: HEIGHT },
  },
}))
